export const toBengaliNumeral = (number: number | string): string => {
  const bengaliNumerals = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯']
  return number
    .toString()
    .split('')
    .map((char) => {
      const digit = parseInt(char)
      return isNaN(digit) ? char : bengaliNumerals[digit]
    })
    .join('')
}

export const formatCurrency = (amount: number): string => {
  return `৳${toBengaliNumeral(amount)}`
}

export const formatTime = (minutes: number): string => {
  const hrs = Math.floor(minutes / 60)
  const mins = minutes % 60

  let result = ''
  if (hrs > 0) result += `${toBengaliNumeral(hrs)} ঘণ্টা `
  if (mins > 0) result += `${toBengaliNumeral(mins)} মিনিট`

  return result.trim()
}

export const formatDate = (date: Date): string => {
  const months = [
    'জানুয়ারি',
    'ফেব্রুয়ারি',
    'মার্চ',
    'এপ্রিল',
    'মে',
    'জুন',
    'জুলাই',
    'আগস্ট',
    'সেপ্টেম্বর',
    'অক্টোবর',
    'নভেম্বর',
    'ডিসেম্বর',
  ]

  const day = toBengaliNumeral(date.getDate())
  const month = months[date.getMonth()]
  const year = toBengaliNumeral(date.getFullYear())

  return `${day} ${month}, ${year}`
}
